module.exports = __webpack_public_path__ + "img/multiplier_3_zh.91094d36.png";